import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';
import { stringifyQuery } from 'utils/query';

export interface IQuickTimeEntriesSearchQuery {
  page: number;
  page_size: number;
  // search?: string;
  // sort?: 'firstName' | 'roleId' | '';
}

export interface SelectedJob {
  id: number;
  name: string;
  longitude: number;
  latitude: number;
  radius: number;
  requireGeofence: number;
  companyId: number;
  created_at: Date;
  updated_at: Date;
  deleted_at?: any;
  street: string;
  landmark: string;
  city: string;
  state: string;
  zip_code: string;
  country: string;
  jobCode?: any;
  rate: number;
  job_status: number;
  contactRequired: number;
  contact_name: string;
  contact_phone: string;
  contact_mobile: string;
  contact_email: string;
  description: string;
  track_mileage: number;
  on_arrival: number;
  on_departure: number;
}

export interface QuickTimeEntriesObject {
  userId: number;
  firstName: string;
  lastName: string;
  email: string;
  roleName: string;
  clocked_status: number;
  employee_image: string;
  selected_job: SelectedJob;
  selected_task?: any;
}

export const fetchPaginatedQuickTimeEntries = (
  searchQuery: IQuickTimeEntriesSearchQuery
): Promise<{ status: boolean; message: string; meta_data: any; payload: QuickTimeEntriesObject[] }> => {
  const stringifiedQuery = stringifyQuery(searchQuery);
  const newEndpoints = endpoints.timesheet.quickTimeEntry + '?' + stringifiedQuery;
  return http().get(newEndpoints);
};

export function useFetchPaginatedQuickTimeEntries(
  searchQuery: IQuickTimeEntriesSearchQuery,
  options?: any
): UseQueryResult<any> {
  return useQuery({
    queryKey: ['fetchPaginatedQuickTimeEntries', searchQuery],
    queryFn: () => fetchPaginatedQuickTimeEntries(searchQuery),
    ...options,
  });
}
